import { render, staticRenderFns } from "./AddNewModule.vue?vue&type=template&id=7535baba&scoped=true"
import script from "./AddNewModule.vue?vue&type=script&lang=js"
export * from "./AddNewModule.vue?vue&type=script&lang=js"
import style0 from "./AddNewModule.vue?vue&type=style&index=0&id=7535baba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7535baba",
  null
  
)

export default component.exports